import React from 'react';
import { isRouteErrorResponse, useRouteError } from 'react-router-dom';

export const InternalServerErrorPage: React.FC = () => {
  const error = useRouteError();
  let message = 'Ocorreu um erro inesperado.';

  if (isRouteErrorResponse(error)) {
    message = error.statusText || message;
  } else if (error instanceof Error && error.message) {
    message = error.message;
  }

  return (
    <div className="d-flex flex-column align-items-center justify-content-center py-5 text-center gap-3">
      <h1 className="display-5 fw-bold">500</h1>
      <p className="text-muted mb-1">Algo deu errado.</p>
      <p className="text-muted">{message}</p>
      <a className="btn btn-primary" href="/">
        Tentar novamente
      </a>
    </div>
  );
};
